import React from "react";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import StyleIcon from "@mui/icons-material/Style";
import SpecialDatesTab from "../Pricing/Components/SpecialDatesTab";

const BanquetSpecialDates = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container maxWidth="xl" disableGutters={isMobile} sx={{ px: { xs: 0, sm: 1, md: 2 } }}>
      <Box sx={{ pb: { xs: 10, sm: 12 } }}>
        <Typography
          gutterBottom
          sx={{
            fontWeight: 900,
            display: "flex",
            alignItems: "center",
            color: "text.primary",
            pb: 1,
            fontSize: { xs: 16, sm: 18, md: 20 },
          }}
          variant="subtitle1"
        >
          <StyleIcon sx={{ mr: 1, width: { xs: 22, sm: 26, md: 28 }, height: { xs: 22, sm: 26, md: 28 } }} />
          Banquet Special Dates
        </Typography>

        <SpecialDatesTab />
      </Box>
    </Container>
  );
};

export default BanquetSpecialDates;
